if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.section = document.getElementById(`shopify-section-${this.sectionId}`);
      this.productForm = this.section.querySelector(`product-form[data-section-id="${this.sectionId}"]`);
      this.stopEl = this.getStopEl();
      this.stopPadding = 20;
      this.base = 20;
      let lastY = 0;

      this.observer = new IntersectionObserver(([entry]) => {
        // Mobile show/hide is position-based in updatePark (so it re-shows on scroll-up); desktop only here.
        if (window.matchMedia('(max-width: 989px)').matches) return;
        const currentY = entry.boundingClientRect.y;
        const scrollingDown = currentY < lastY;
        lastY = currentY;

        if (!entry.isIntersecting && scrollingDown) {
          this.classList.add('sticky-atc--active');
        } else {
          this.classList.remove('sticky-atc--active');
        }
      });

      this.observer.observe(this.productForm);

      // Float fixed at the bottom; parks as position:absolute at the FAQ media — no jitter.
      this.onScroll = () => this.updatePark();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.updatePark();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    getStopEl() {
      return document.querySelector('.faq__media')
        || document.querySelector('.faq-section')
        || document.querySelector('.faq');
    }

    // Mobile: the reviews section — sticky hides once its end scrolls into view.
    getReviewsEl() {
      const w = document.querySelector('.jdgm-rev-widg');
      return w ? (w.closest('.shopify-section') || w) : null;
    }

    updatePark() {
      if (this.rafPending) return;
      this.rafPending = true;
      requestAnimationFrame(() => {
        this.rafPending = false;
        // Mobile: no desktop float/park (parked absolute breaks on iOS); stay a fixed bottom bar.
        if (window.matchMedia('(max-width: 989px)').matches) {
          if (this.style.position) {
            this.style.position = '';
            this.style.top = '';
            this.style.left = '';
            this.style.insetBlockEnd = '';
            this.style.insetInlineEnd = '';
            this.style.marginInlineStart = '';
            this._top = this._left = null;
          }
          const reviews = this.getReviewsEl();
          const pastReviews = reviews ? reviews.getBoundingClientRect().bottom < window.innerHeight : false;
          const formPassed = this.productForm ? this.productForm.getBoundingClientRect().bottom < 0 : false;
          // Show once scrolled below the main ATC; hide past the reviews or back up at the ATC.
          this.classList.toggle('sticky-atc--active', formPassed && !pastReviews);
          return;
        }
        if (!this.stopEl || !this.stopEl.isConnected) this.stopEl = this.getStopEl();
        if (!this.stopEl) return;

        const mediaBottomDoc = this.stopEl.getBoundingClientRect().bottom + window.scrollY;
        const parkBottomDoc = mediaBottomDoc - this.stopPadding;
        const floatBottomDoc = window.scrollY + window.innerHeight - this.base;

        if (floatBottomDoc < parkBottomDoc) {
          // Floating (fixed via CSS). Remember its right-edge x so the dock matches it exactly.
          if (this.style.position === 'absolute') {
            this.style.position = '';
            this.style.top = '';
            this.style.left = '';
            this.style.insetBlockEnd = '';
            this.style.insetInlineEnd = '';
            this.style.marginInlineStart = '';
            this._top = this._left = null;
          }
          const r = this.getBoundingClientRect();
          if (r.width) this._floatRight = r.right + window.scrollX;
          return;
        }

        // Docked: absolute, pinned to the media bottom; right edge locked to the float x — no jitter.
        if (this.style.position !== 'absolute') {
          this.style.position = 'absolute';
          this.style.insetBlockEnd = 'auto';
          this.style.insetInlineEnd = 'auto';
          this.style.marginInlineStart = '0';
        }
        const op = this.offsetParent;
        const opRect = op ? op.getBoundingClientRect() : { top: 0, left: 0 };
        const opTopDoc = opRect.top + window.scrollY;
        const opLeftDoc = opRect.left + window.scrollX;
        const rightDocX = (this._floatRight != null)
          ? this._floatRight
          : this.stopEl.getBoundingClientRect().right + window.scrollX - this.stopPadding;
        const top = Math.round(parkBottomDoc - this.offsetHeight - opTopDoc);
        const left = Math.round(rightDocX - this.offsetWidth - opLeftDoc);
        if (this._top !== top || this._left !== left) {
          this._top = top;
          this._left = left;
          this.style.top = `${top}px`;
          this.style.left = `${left}px`;
        }
      });
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
